// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.telRecordDialog[data-v-705cec4b] {\n  z-index: 10;\n}\n.telRecordDialog[data-v-705cec4b] .el-dialog__header {\n  padding: 0 20px;\n}\n.telRecordDialog[data-v-705cec4b] .el-dialog__body {\n  padding-top: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
